import { createFileRoute } from "@tanstack/react-router";
import { ReturnsContainer } from "@/features/returns";

export const Route = createFileRoute("/$store/_layout/returns")({
	component: ReturnsPage,
});

function ReturnsPage() {
	return <ReturnsContainer />;
}
